// extracted by mini-css-extract-plugin
module.exports = {"topBanner":"_35GmEq","superTcgDetail":"_2FE7up"};